import { useCallback } from 'react';
import { redirect } from 'react-router-dom';
import { ACTIVE_TAB_PARAM } from '../constants';
import { ReviewTab } from '../types';

const DEFAULT_REVIEW_TAB = ReviewTab.SIMULATIONS;

/**
 * Returns a Router loader for the Review page.
 */
const useReviewLoader = () => {
  const reviewLoader = useCallback(({ request }: { request: Request }) => {
    const url = new URL(request.url);
    const activeTab = url.searchParams.get(ACTIVE_TAB_PARAM);

    const isValidTab = Object.values(ReviewTab).includes(activeTab as ReviewTab);
    const hasTab = !!activeTab && isValidTab;

    // If no tab is selected, set the default tab.
    if (!hasTab) {
      url.searchParams.set(ACTIVE_TAB_PARAM, DEFAULT_REVIEW_TAB);
      return redirect(url.pathname + url.search);
    }

    // If no redirects were needed, return null to continue with the current URL
    return null;
  }, []);

  return reviewLoader;
};

export default useReviewLoader;
